const Log = {
  create: (log, severity) => ({ url: '/logs/create', params: { log, severity } }),
  heartbeat: (logType) => ({ url: '/logs/heartbeat', params: { log_type: logType } }),
};

export default Log;
